import type { ContactChoiceField } from '../contact-form-content.types';

/**
 * Options as the legacy component hands them to `InputSelect`, `{ label, value }`. `InputSelect` spreads
 * every other key of an option onto its `<option>`, so the `name` the Sitecore adapter adds and Sanity's
 * `_key`/`_type` must not reach it. Sanity has no `value`; it is the option's `name`, equal on every
 * Sitecore item that has both.
 */
export const optionsOf = (field: ContactChoiceField | undefined) =>
  (field?.options ?? []).map(({ label, value, name }) => ({ label: label ?? '', value: value ?? name ?? '' }));
